// extracted by mini-css-extract-plugin
export default {"errorPageWrapper":"styles_errorPageWrapper__MoNe0","pageContent":"styles_pageContent__LjNzP"};